/**
 * OUTLAST collection pages: per-card swipe gallery on mobile.
 * - Swiping uses native scroll-snap (smooth, iOS/Android, page still scrolls vertically).
 * - Dots show the position. Each card is independent.
 * - Follows the card's selected color swatch (filters to that color's photos, or jumps to its photo).
 * - A swipe never opens the product; a normal tap does.
 * Works for cards added later by filters, sorting and infinite scroll.
 */
( function() {
	'use strict';

	if ( window.__oraCollectionGallery ) {
		return;
	}
	window.__oraCollectionGallery = true;

	function slidesOf( gallery ) {
		return Array.prototype.slice.call( gallery.querySelectorAll( '.ora-card-gallery__slide' ) );
	}

	function visibleSlides( gallery ) {
		return slidesOf( gallery ).filter( function( s ) { return ! s.hidden; } );
	}

	function buildDots( gallery ) {
		var dots = gallery.querySelector( '[data-ora-dots]' ),
			count = visibleSlides( gallery ).length;
		if ( ! dots ) {
			return;
		}
		dots.innerHTML = '';
		if ( count < 2 ) {
			return;
		}
		for ( var i = 0; i < count; i++ ) {
			var d = document.createElement( 'span' );
			d.className = 'ora-card-gallery__dot' + ( i === 0 ? ' is-active' : '' );
			dots.appendChild( d );
		}
	}

	function updateDots( gallery ) {
		var track = gallery.querySelector( '[data-ora-track]' ),
			dots  = gallery.querySelectorAll( '.ora-card-gallery__dot' );
		if ( ! track || ! dots.length || ! track.clientWidth ) {
			return;
		}
		var index = Math.round( track.scrollLeft / track.clientWidth );
		for ( var i = 0; i < dots.length; i++ ) {
			dots[ i ].classList.toggle( 'is-active', i === index );
		}
	}

	function goTo( gallery, index, smooth ) {
		var track = gallery.querySelector( '[data-ora-track]' );
		if ( ! track ) {
			return;
		}
		track.scrollTo( { left: index * track.clientWidth, behavior: smooth ? 'smooth' : 'auto' } );
		updateDots( gallery );
	}

	// Show only one color's photos (grouped galleries), or jump to that color's photo.
	function applyColor( card, value, href ) {
		var gallery = card.querySelector( '[data-ora-gallery]' );
		if ( ! gallery || ! value ) {
			return;
		}

		var slides = slidesOf( gallery );

		if ( href ) {
			slides.forEach( function( s ) { s.href = href; } );
		}

		if ( gallery.hasAttribute( 'data-grouped' ) ) {
			var match = slides.filter( function( s ) { return s.dataset.color === value; } );
			if ( ! match.length ) {
				return; // color card: already only its own photos
			}
			slides.forEach( function( s ) { s.hidden = s.dataset.color !== value; } );
			buildDots( gallery );
			goTo( gallery, 0, false );
			loadAround( gallery );
			return;
		}

		// Not grouped: jump to the color's own photo using the card's variant data.
		var json = card.querySelector( '[data-product-variants]' );
		if ( ! json ) {
			return;
		}
		var variants = [];
		try {
			variants = JSON.parse( json.textContent );
		} catch ( e ) {
			return;
		}
		var v = variants.find( function( x ) { return x.options.indexOf( value ) !== -1 && x.featured_media; } );
		if ( ! v ) {
			return;
		}
		var target = visibleSlides( gallery ).findIndex( function( s ) { return String( s.dataset.mediaId ) === String( v.featured_media.id ); } );
		if ( target >= 0 ) {
			goTo( gallery, target, true );
		}
	}

	// Preload the photo before/after the visible one so a swipe never shows a blank slide.
	function loadAround( gallery ) {
		var track = gallery.querySelector( '[data-ora-track]' ),
			vis   = visibleSlides( gallery );
		if ( ! track || ! vis.length ) {
			return;
		}
		var index = track.clientWidth ? Math.round( track.scrollLeft / track.clientWidth ) : 0;
		for ( var i = index - 1; i <= index + 2; i++ ) {
			var img = vis[ i ] && vis[ i ].querySelector( 'img' );
			if ( img && img.getAttribute( 'loading' ) !== 'eager' ) {
				img.setAttribute( 'loading', 'eager' );
			}
		}
	}

	// Start preloading a card's next photo only when the card is (almost) on screen.
	var nearObserver = 'IntersectionObserver' in window ? new IntersectionObserver( function( entries ) {
		entries.forEach( function( entry ) {
			if ( entry.isIntersecting ) {
				loadAround( entry.target );
				nearObserver.unobserve( entry.target );
			}
		} );
	}, { rootMargin: '300px 0px' } ) : null;

	function initGallery( gallery ) {
		if ( gallery.dataset.oraReady ) {
			return;
		}
		gallery.dataset.oraReady = '1';

		var track = gallery.querySelector( '[data-ora-track]' ),
			card  = gallery.closest( '.product-card' );
		if ( ! track ) {
			return;
		}

		// Start on the card's selected color.
		var selected = card ? card.querySelector( '.product-swatches .swatch.selected' ) : null;
		if ( selected && ! selected.hasAttribute( 'data-ora-link' ) ) {
			applyColor( card, selected.getAttribute( 'data-value' ), null );
		}

		buildDots( gallery );

		if ( nearObserver ) {
			nearObserver.observe( gallery );
		} else {
			loadAround( gallery );
		}
		track.addEventListener( 'touchstart', function() { loadAround( gallery ); }, { passive: true } );

		var ticking = false;
		track.addEventListener( 'scroll', function() {
			gallery.dataset.swiping = String( Date.now() );
			if ( ticking ) {
				return;
			}
			ticking = true;
			window.requestAnimationFrame( function() {
				ticking = false;
				updateDots( gallery );
				loadAround( gallery );
			} );
		}, { passive: true } );

		// A swipe must never open the product page.
		track.addEventListener( 'click', function( e ) {
			var last = parseInt( gallery.dataset.swiping || '0', 10 );
			if ( Date.now() - last < 250 ) {
				e.preventDefault();
				e.stopPropagation();
			}
		}, true );
	}

	function initAll( root ) {
		( root || document ).querySelectorAll( '[data-ora-gallery]' ).forEach( initGallery );
	}

	// Color swatch on a normal card -> gallery follows (theme.js still updates everything else).
	document.addEventListener( 'click', function( e ) {
		var swatch = e.target.closest( '.product-card .product-swatches .swatch' );
		if ( ! swatch || swatch.hasAttribute( 'data-ora-link' ) ) {
			return;
		}
		var card = swatch.closest( '.product-card' );
		if ( card ) {
			applyColor( card, swatch.getAttribute( 'data-value' ), swatch.getAttribute( 'href' ) );
		}
	} );

	document.addEventListener( 'product-card-updated', function() { initAll(); } );
	document.addEventListener( 'shopify:section:load', function( e ) { initAll( e.target ); } );

	var pending = false;
	new MutationObserver( function( records ) {
		if ( pending ) {
			return;
		}
		for ( var i = 0; i < records.length; i++ ) {
			if ( records[ i ].addedNodes.length ) {
				pending = true;
				window.requestAnimationFrame( function() {
					pending = false;
					initAll();
				} );
				return;
			}
		}
	} ).observe( document.body, { childList: true, subtree: true } );

	// Safe to call more than once (each gallery is set up only once).
	initAll();
	document.addEventListener( 'DOMContentLoaded', function() { initAll(); } );
	window.addEventListener( 'load', function() { initAll(); } );
} )();
